import type { ReactNode } from 'react'
import { z } from 'zod'
import { Box } from '../../components/Box.tsx'
import { ToggleButton, ToggleButtonGroup } from '../../components/generic.tsx'
import type { LayerViewId } from './layers.tsx'

export const LayerInputsSchema = z.object({
	'lightning-realtime': z
		.object({ maxAge: z.literal([60, 30]), cloudToGround: z.boolean() })
		.default({ maxAge: 60, cloudToGround: false })
		.catch({ maxAge: 60, cloudToGround: false }),
} satisfies Partial<Record<LayerViewId, unknown>>)
export type LayerInputs = z.infer<typeof LayerInputsSchema>
export type LayerInput<T extends LayerViewId = LayerViewId> = T extends keyof LayerInputs ? LayerInputs[T] : Record<string, never>

interface ToggleButtonInputProps<T extends string | boolean | number> {
	options: { value: T; label: ReactNode; disabled?: boolean; key: string }[]
	selected: T
	onChange: (value: T) => void
}
export const ToggleButtonInput = <T extends string | boolean | number>({ options, selected, onChange }: ToggleButtonInputProps<T>) => (
	<Box display='flex' justifyContent='center' width='100%'>
		<ToggleButtonGroup size='small' exclusive fullWidth sx={{ width: '100%', my: 1 }}>
			{options.map((opt) => (
				<ToggleButton
					key={opt.key}
					value={opt.value}
					selected={selected === opt.value}
					onChange={() => onChange(opt.value)}
					disabled={opt.disabled}
				>
					{opt.label}
				</ToggleButton>
			))}
		</ToggleButtonGroup>
	</Box>
)
